export default {
    startTourIfPayed(state, plans) {
        state.plansInfo = plans;
    },
    startTourMut(state, payload) {
        state[payload.tourName] = payload.isStart;
    }
};
